/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Skills16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M14.122 3.585a2.108 2.108 0 00-2.96 0l-8.944 8.92a2.096 2.096 0 002.962 2.962l8.942-8.928a2.103 2.103 0 000-2.954zm-1.184 1.807l-2.162 2.22-.637-.636 2.221-2.221a.378.378 0 01.319-.133c.12.002.235.053.318.14l.06.074a.476.476 0 01-.12.556zM7.608 1.86c.272.155.502.374.673.636.109.18.203.368.282.563l.044.103c.08-.192.172-.38.274-.562.146-.246.343-.458.577-.622.17-.117.35-.217.54-.296l.178-.082a7.262 7.262 0 01-.547-.266 1.85 1.85 0 01-.696-.659 4.152 4.152 0 01-.296-.607V.032a4.394 4.394 0 01-.252.533c-.159.28-.382.52-.651.696-.177.105-.36.2-.548.281l-.119.045c.189.074.37.165.54.274zM5.66 4.896c.198.113.366.273.488.466.078.131.147.267.208.407v.067c.055-.14.12-.276.192-.407.106-.177.247-.331.415-.452a2.33 2.33 0 01.4-.222l.162-.067a1.558 1.558 0 01-.385-.192 1.38 1.38 0 01-.503-.489 2.357 2.357 0 01-.215-.429c-.059.14-.118.26-.185.385-.127.198-.3.363-.503.481-.137.08-.281.15-.43.207h-.088c.153.072.301.154.444.245z"
        />
    </AccessibleSVG>
);

export default Skills16;
